var _ = require('./lodash.min').runInContext();
module.exports = require('./fp/_baseConvert')(_, _);



//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/~/lodash/fp.js
// module id = 6
// module chunks = 0